"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Navigation, Pagination, Autoplay } from "swiper/modules";
import Image from "next/image";
import Link from "@/components/Link";
import type { HomeSlider } from "@/lib/navigation";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";

interface HeroSliderProps {
  slides: HomeSlider[];
}

export default function HeroSlider({ slides }: HeroSliderProps) {
  if (!slides || slides.length === 0) return null;

  return (
    <div className="th-hero-wrapper hero-1" id="hero">
      <Swiper
        className="th-slider hero-slider-1"
        modules={[EffectFade, Navigation, Pagination, Autoplay]}
        effect="fade"
        loop={true}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        pagination={{ el: ".hero-slider-pagination", clickable: true }}
        navigation={{
          prevEl: ".hero-slider-prev",
          nextEl: ".hero-slider-next",
        }}
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id}>
            <div className="hero-inner">
              <div
                className="th-hero-bg"
                style={{
                  backgroundImage: `url(${slide.photoURL?.replace(/ /g, "%20")})`,
                }}
              ></div>
              <div className="container">
                <div className="hero-style1">
                  <span
                    className="sub-title style1"
                    data-ani="slideinup"
                    data-ani-delay="0.2s"
                  >
                    {slide.subTitle || "Central Holidays"}
                  </span>
                  {/* h2 for the document outline — the page's single h1 lives
                      on the homepage. `.h1` re-applies the h1 type scale the
                      theme keys off the element, so the slide looks identical. */}
                  <h2
                    className="hero-title h1"
                    data-ani="slideinup"
                    data-ani-delay="0.4s"
                  >
                    {slide.title}
                  </h2>
                  <div
                    className="btn-group"
                    data-ani="slideinup"
                    data-ani-delay="0.6s"
                  >
                    {slide.packageId && (
                      <Link
                        href={slide.packageId}
                        className="th-btn th-icon"
                        title={`More details: ${slide.title}`}
                      >
                        More Details
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="th-swiper-custom">
        <button className="slider-arrow slider-prev hero-slider-prev">
          <Image
            width={24}
            height={24}
            src="/main/img/icon/right-arrow.svg"
            alt=""
          />
        </button>
        <div className="slider-pagination hero-slider-pagination"></div>
        <button className="slider-arrow slider-next hero-slider-next">
          <Image
            width={24}
            height={24}
            src="/main/img/icon/left-arrow.svg"
            alt=""
          />
        </button>
      </div>
    </div>
  );
}
